// import React, { useState, useCallback } from "react";
// import { useDropzone } from "react-dropzone";
// import axios from "axios";
// import "./DataUpload.css";

// const DataUpload = () => {
//   const [files, setFiles] = useState([]);
//   const [uploading, setUploading] = useState(false);
//   const [uploadStatus, setUploadStatus] = useState("");

//   // Drag and Drop Handling
//   const onDrop = useCallback((acceptedFiles) => {
//     setFiles(acceptedFiles);
//   }, []);

//   const { getRootProps, getInputProps, isDragActive } = useDropzone({
//     onDrop,
//     accept: "*", // Accepts all file types
//   });

//   // Upload to Server
//   const handleUpload = async () => {
//     if (files.length === 0) {
//       alert("Please select files to upload.");
//       return;
//     }

//     setUploading(true);
//     const formData = new FormData();
//     files.forEach((file) => formData.append("files", file));

//     try {
//       const response = await axios.post("http://localhost:5001/upload-data", formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       if (response.data.paths) {
//         setUploadStatus("Upload successful!");
//         alert("Files uploaded successfully!");
//       } else {
//         setUploadStatus("Upload failed.");
//         alert("Upload failed!");
//       }
//     } catch (error) {
//       console.error("Error uploading files:", error);
//       setUploadStatus("Upload failed.");
//       alert("Upload failed!");
//     } finally {
//       setUploading(false);
//     }
//   };

//   return (
//     <div className="upload-container">
//       <h2>Upload Data</h2>

//       {/* Drag & Drop Section */}
//       <div {...getRootProps()} className={`dropzone ${isDragActive ? "active" : ""}`}>
//         <input {...getInputProps()} />
//         {isDragActive ? <p>Drop the files here...</p> : <p>Drag & Drop files or Click to Select</p>}
//       </div>

//       {/* File Preview */}
//       {files.length > 0 && (
//         <div className="file-preview">
//           {files.map((file, index) => (
//             <p key={index}>📄 {file.name}</p>
//           ))}
//         </div>
//       )}

//       {/* Upload Button */}
//       <button onClick={handleUpload} disabled={uploading} className="upload-button">
//         {uploading ? "Uploading..." : "Upload"}
//       </button>
//     </div>
//   );
// };

// export default DataUpload;


import React, { useState, useCallback, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import { auth } from "../firebaseConfig"; // Ensure the correct import
import "./DataUpload.css";

const DataUpload = () => {
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadStatus, setUploadStatus] = useState("");
  const [username, setUsername] = useState("");

  // Fetch logged-in user
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUsername(user.email.split("@")[0]); // Extract username from email
      } else {
        setUsername("");
      }
    });

    return () => unsubscribe();
  }, []);

  // Drag & Drop Handling
  const onDrop = useCallback((acceptedFiles) => {
    setFiles((prevFiles) => [...prevFiles, ...acceptedFiles]);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: "*", // Accepts all file types
  });

  // Upload Files to Server
  const handleUpload = async () => {
    if (files.length === 0) {
      alert("Please select files to upload.");
      return;
    }

    const user = auth.currentUser;
    if (!user) {
      alert("User not logged in.");
      return;
    }

    setUploading(true);
    setUploadStatus("");

    const formData = new FormData();
    files.forEach((file) => formData.append("files", file));
    formData.append("username", username); // Send username

    try {
      const response = await axios.post("https://databoltahi.com/upload-data", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.paths) {
        setUploadStatus("Upload successful!");
        alert("Files uploaded successfully!");
        setFiles([]); // Clear uploaded files
      } else {
        setUploadStatus("Upload failed.");
        alert("Upload failed!");
      }
    } catch (error) {
      console.error("Error uploading files:", error.response?.data || error.message);
      setUploadStatus("Upload failed.");
      alert("Upload failed!");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="upload-container">
      <h2>Upload Data</h2>
      <p>Logged in as: <strong>{username || "Not logged in"}</strong></p>

      {/* Drag & Drop Section */}
      <div {...getRootProps()} className={`dropzone ${isDragActive ? "active" : ""}`}>
        <input {...getInputProps()} />
        {isDragActive ? <p>Drop the files here...</p> : <p>Drag & Drop files or Click to Select</p>}
      </div>

      {/* File Preview */}
      {files.length > 0 && (
        <div className="file-preview">
          {files.map((file, index) => (
            <p key={index}>📄 {file.name}</p>
          ))}
        </div>
      )}

      {/* Upload Button */}
      <button onClick={handleUpload} disabled={uploading} className="upload-button">
        {uploading ? "Uploading..." : "Upload"}
      </button>

      {/* Upload Status */}
      {uploadStatus && <p className="upload-status">{uploadStatus}</p>}
    </div>
  );
};

export default DataUpload;
